export const countries = [
  { value: 'FR', text: 'France' },
  {
    value: 'AF', text: 'Afghanistan'
  },
  {
    value: 'ZA', text: 'Afrique du Sud'
  },
  {
    value: 'AL', text: 'Albanie'
  },
  {
    value: 'DZ', text: 'Algérie'
  },
  {
    value: 'DE', text: 'Allemagne'
  },
  {
    value: 'AD', text: 'Andorre'
  },
  {
    value: 'AO', text: 'Angola'
  },
  {
    value: 'AG', text: 'Antigua-et-Barbuda'
  },
  {
    value: 'SA', text: 'Arabie saoudite'
  },
  {
    value: 'AR', text: 'Argentine'
  },
  {
    value: 'AM', text: 'Arménie'
  },
  {
    value: 'AU', text: 'Australie'
  },
  {
    value: 'AT', text: 'Autriche'
  },
  {
    value: 'AZ', text: 'Azerbaïdjan'
  },
  {
    value: 'BS', text: 'Bahamas'
  },
  {
    value: 'BH', text: 'Bahreïn'
  },
  {
    value: 'BD', text: 'Bangladesh'
  },
  {
    value: 'BB', text: 'Barbade'
  },
  {
    value: 'BE', text: 'Belgique'
  },
  {
    value: 'BZ', text: 'Belize'
  },
  {
    value: 'BJ', text: 'Bénin'
  },
  {
    value: 'BT', text: 'Bhoutan'
  },
  {
    value: 'BY', text: 'Biélorussie'
  },
  {
    value: 'MM', text: 'Birmanie'
  },
  {
    value: 'BO', text: 'Bolivie'
  },
  {
    value: 'BA', text: 'Bosnie-Herzégovine'
  },
  {
    value: 'BW', text: 'Botswana'
  },
  {
    value: 'BR', text: 'Brésil'
  },
  {
    value: 'BN', text: 'Brunei'
  },
  {
    value: 'BG', text: 'Bulgarie'
  },
  {
    value: 'BF', text: 'Burkina'
  },
  {
    value: 'BI', text: 'Burundi'
  },
  {
    value: 'KH', text: 'Cambodge'
  },
  {
    value: 'CM', text: 'Cameroun'
  },
  {
    value: 'CA', text: 'Canada'
  },
  {
    value: 'CV', text: 'Cap-Vert'
  },
  {
    value: 'CL', text: 'Chili'
  },
  {
    value: 'CN', text: 'Chine'
  },
  {
    value: 'CY', text: 'Chypre'
  },
  {
    value: 'CO', text: 'Colombie'
  },
  {
    value: 'KM', text: 'Comores'
  },
  {
    value: 'CG', text: 'Congo'
  },
  {
    value: 'KP', text: 'Corée du Nord'
  },
  {
    value: 'KR', text: 'Corée du Sud'
  },
  {
    value: 'CR', text: 'Costa Rica'
  },
  {
    value: 'CI', text: "Côte d'Ivoire"
  },
  {
    value: 'HR', text: 'Croatie'
  },
  {
    value: 'CU', text: 'Cuba'
  },
  {
    value: 'DK', text: 'Danemark'
  },
  {
    value: 'DJ', text: 'Djibouti'
  },
  {
    value: 'DO', text: 'Dominique'
  },
  {
    value: 'EG', text: 'Égypte'
  },
  {
    value: 'AE', text: 'Émirats arabes unis'
  },
  {
    value: 'EC', text: 'Équateur'
  },
  {
    value: 'ER', text: 'Érythrée'
  },
  {
    value: 'ES', text: 'Espagne'
  },
  {
    value: 'EE', text: 'Estonie'
  },
  {
    value: 'US', text: 'États-Unis'
  },
  {
    value: 'ET', text: 'Éthiopie'
  },
  {
    value: 'FJ', text: 'Fidji'
  },
  {
    value: 'FI', text: 'Finlande'
  },
  {
    value: 'GA', text: 'Gabon'
  },
  {
    value: 'GM', text: 'Gambie'
  },
  {
    value: 'GE', text: 'Géorgie'
  },
  {
    value: 'GH', text: 'Ghana'
  },
  {
    value: 'GR', text: 'Grèce'
  },
  {
    value: 'GD', text: 'Grenade'
  },
  {
    value: 'GT', text: 'Guatemala'
  },
  {
    value: 'GN', text: 'Guinée'
  },
  {
    value: 'GQ', text: 'Guinée équatoriale'
  },
  {
    value: 'GW', text: 'Guinée-Bissau'
  },
  {
    value: 'GY', text: 'Guyana'
  },
  {
    value: 'HT', text: 'Haïti'
  },
  {
    value: 'HN', text: 'Honduras'
  },
  {
    value: 'HU', text: 'Hongrie'
  },
  {
    value: 'IN', text: 'Inde'
  },
  {
    value: 'ID', text: 'Indonésie'
  },
  {
    value: 'IQ', text: 'Irak'
  },
  {
    value: 'IR', text: 'Iran'
  },
  {
    value: 'IE', text: 'Irlande'
  },
  {
    value: 'IS', text: 'Islande'
  },
  {
    value: 'IL', text: 'Israël'
  },
  {
    value: 'IT', text: 'Italie'
  },
  {
    value: 'JM', text: 'Jamaïque'
  },
  {
    value: 'JP', text: 'Japon'
  },
  {
    value: 'JO', text: 'Jordanie'
  },
  {
    value: 'KZ', text: 'Kazakhstan'
  },
  {
    value: 'KE', text: 'Kenya'
  },
  {
    value: 'KG', text: 'Kirghizistan'
  },
  {
    value: 'KI', text: 'Kiribati'
  },
  {
    value: 'KW', text: 'Koweït'
  },
  {
    value: 'LA', text: 'Laos'
  },
  {
    value: 'LS', text: 'Lesotho'
  },
  {
    value: 'LV', text: 'Lettonie'
  },
  {
    value: 'LB', text: 'Liban'
  },
  {
    value: 'LR', text: 'Libéria'
  },
  {
    value: 'LY', text: 'Libye'
  },
  {
    value: 'LI', text: 'Liechtenstein'
  },
  {
    value: 'LT', text: 'Lituanie'
  },
  {
    value: 'LU', text: 'Luxembourg'
  },
  {
    value: 'MG', text: 'Madagascar'
  },
  {
    value: 'MY', text: 'Malaisie'
  },
  {
    value: 'MW', text: 'Malawi'
  },
  {
    value: 'MV', text: 'Maldives'
  },
  {
    value: 'ML', text: 'mali'
  },
  {
    value: 'MT', text: 'Malte'
  },
  {
    value: 'MA', text: 'Maroc'
  },
  {
    value: 'MH', text: 'Marshall'
  },
  {
    value: 'MU', text: 'Maurice'
  },
  {
    value: 'MR', text: 'Mauritanie'
  },
  {
    value: 'MX', text: 'Mexique'
  },
  {
    value: 'FM', text: 'Micronésie'
  },
  {
    value: 'MD', text: 'Moldavie'
  },
  {
    value: 'MC', text: 'Monaco'
  },
  {
    value: 'MN', text: 'Mongolie'
  },
  {
    value: 'ME', text: 'Monténégro'
  },
  {
    value: 'MZ', text: 'Mozambique'
  },
  {
    value: 'NA', text: 'Namibie'
  },
  {
    value: 'NR', text: 'Nauru'
  },
  {
    value: 'NP', text: 'Népal'
  },
  {
    value: 'NI', text: 'Nicaragua'
  },
  {
    value: 'NE', text: 'Niger'
  },
  {
    value: 'NG', text: 'Nigeria'
  },
  {
    value: 'NO', text: 'Norvège'
  },
  {
    value: 'NZ', text: 'Nouvelle-Zélande'
  },
  {
    value: 'OM', text: 'Oman'
  },
  {
    value: 'UG', text: 'Ouganda'
  },
  {
    value: 'UZ', text: 'Ouzbékistan'
  },
  {
    value: 'PK', text: 'Pakistan'
  },
  {
    value: 'PW', text: 'Palaos'
  },
  {
    value: 'PS', text: 'Palestine'
  },
  {
    value: 'PA', text: 'Panama'
  },
  {
    value: 'PG', text: 'Papouasie-Nouvelle-Guinée'
  },
  {
    value: 'PY', text: 'Paraguay'
  },
  {
    value: 'NL', text: 'Pays-Bas'
  },
  {
    value: 'PE', text: 'Pérou'
  },
  {
    value: 'PH', text: 'Philippines'
  },
  {
    value: 'PL', text: 'Pologne'
  },
  {
    value: 'PR', text: 'Porto Rico'
  },
  {
    value: 'PT', text: 'Portugal'
  },
  {
    value: 'QA', text: 'Qatar'
  },
  {
    value: 'CF', text: 'République centrafricaine'
  },
  {
    value: 'MK', text: 'République de Macédoine'
  },
  {
    value: 'CD', text: 'République démocratique du Congo'
  },
  {
    value: 'DO', text: 'république dominicaine'
  },
  {
    value: 'CZ', text: 'République tchèque'
  },
  {
    value: 'RO', text: 'Roumanie'
  },
  {
    value: 'GB', text: 'Royaume-Uni'
  },
  {
    value: 'RU', text: 'Russie'
  },
  {
    value: 'RW', text: 'Rwanda'
  },
  {
    value: 'KN', text: 'Saint-Christophe-et-Niévès'
  },
  {
    value: 'LC', text: 'Sainte-Lucie'
  },
  {
    value: 'SM', text: 'Saint-Marin'
  },
  {
    value: 'VC', text: 'Saint-Vincent-et-les Grenadines'
  },
  {
    value: 'SB', text: 'Salomon'
  },
  {
    value: 'SV', text: 'Salvador'
  },
  {
    value: 'WS', text: 'Samoa'
  },
  {
    value: 'ST', text: 'Sao Tomé-et-Principe'
  },
  {
    value: 'SN', text: 'Sénégal'
  },
  {
    value: 'RS', text: 'Serbie'
  },
  {
    value: 'SC', text: 'Seychelles'
  },
  {
    value: 'SL', text: 'Sierra Leone'
  },
  {
    value: 'SG', text: 'Singapour'
  },
  {
    value: 'SK', text: 'Slovaquie'
  },
  {
    value: 'SI', text: 'Slovénie'
  },
  {
    value: 'SO', text: 'Somalie'
  },
  {
    value: 'SD', text: 'Soudan'
  },
  {
    value: 'LK', text: 'Sri Lanka'
  },
  {
    value: 'SS', text: 'Sud-Soudan'
  },
  {
    value: 'SE', text: 'Suède'
  },
  {
    value: 'CH', text: 'Suisse'
  },
  {
    value: 'SR', text: 'Suriname'
  },
  {
    value: 'SZ', text: 'Swaziland'
  },
  {
    value: 'SY', text: 'Syrie'
  },
  {
    value: 'TJ', text: 'Tadjikistan'
  },
  {
    value: 'TW', text: 'Taïwan'
  },
  {
    value: 'TZ', text: 'Tanzanie'
  },
  {
    value: 'TD', text: 'Tchad'
  },
  {
    value: 'TH', text: 'Thaïlande'
  },
  {
    value: 'TL', text: 'Timor oriental'
  },
  {
    value: 'TG', text: 'Togo'
  },
  {
    value: 'TO', text: 'Tonga'
  },
  {
    value: 'TT', text: 'Trinité-et-Tobago'
  },
  {
    value: 'TN', text: 'Tunisie'
  },
  {
    value: 'TM', text: 'Turkménistan'
  },
  {
    value: 'TR', text: 'Turquie'
  },
  {
    value: 'TV', text: 'Tuvalu'
  },
  {
    value: 'UA', text: 'Ukraine'
  },
  {
    value: 'UY', text: 'Uruguay'
  },
  {
    value: 'VU', text: 'Vanuatu'
  },
  {
    value: 'VA', text: 'Vatican'
  },
  {
    value: 'VE', text: 'Venezuela'
  },
  {
    value: 'VN', text: 'Viêt Nam'
  },
  {
    value: 'YE', text: 'Yémen'
  },
  {
    value: 'ZM', text: 'Zambie'
  },
  {
    value: 'ZW', text: 'Zimbabwe'
  }
];
